import { render, staticRenderFns } from "./BaseIconButtonExpandLessMore.vue?vue&type=template&id=f11c1e6a&scoped=true&"
import script from "./BaseIconButtonExpandLessMore.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonExpandLessMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f11c1e6a",
  null
  
)

export default component.exports